// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";
import { Globe, Mail, Settings } from "lucide-react";

const OverviewTab = ({
  selected,
  emailNotificationsCount = 0,
  apiCallsCount = 0,
}) => {
  if (!selected) return null;

  return (
    <div className="md:space-y-6 space-y-4">
      <div>
        <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100 mb-3">
          Status-Eigenschaften
        </h3>
        <dl className="grid grid-cols-2 gap-6">
          <div>
            <dt className="text-sm font-medium text-slate-500 dark:text-slate-400">
              Position im Workflow
            </dt>
            <dd className="text-lg font-semibold text-slate-900 dark:text-slate-100 mt-1">
              #{selected.position}
            </dd>
          </div>
          <div>
            <dt className="text-sm font-medium text-slate-500 dark:text-slate-400">
              Status-Code
            </dt>
            <dd className="text-lg font-mono text-slate-900 dark:text-slate-100 mt-1">
              {selected.status_code}
            </dd>
          </div>
          <div>
            <dt className="text-sm font-medium text-slate-500 dark:text-slate-400">
              System-Status
            </dt>
            <dd className="mt-1">
              <span className="inline-flex items-center px-2 py-1 rounded text-sm font-medium bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200">
                {selected.is_system_status ? "Ja" : "Nein"}
              </span>
            </dd>
          </div>
          <div>
            <dt className="text-sm font-medium text-slate-500 dark:text-slate-400">
              End-Status
            </dt>
            <dd className="mt-1">
              <span className="inline-flex items-center px-2 py-1 rounded text-sm font-medium bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-200">
                {selected.is_terminal_status ? "Ja" : "Nein"}
              </span>
            </dd>
          </div>
        </dl>
      </div>
      <div>
        <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100 mb-3">
          Konfiguration-Übersicht
        </h3>
        <div className="grid sm:grid-cols-3 grid-cols-1 gap-4">
          <div className="bg-gradient-primary-secondary-tint dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 rounded-lg p-4 text-center">
            <Globe className="w-8 h-8 text-blue-600 dark:text-blue-400 mx-auto mb-2" />
            <div className="text-2xl font-bold text-blue-600 dark:text-blue-400">
              {apiCallsCount}
            </div>
            <div className="text-sm text-blue-700 dark:text-blue-300">
              API-Aufrufe
            </div>
          </div>
          <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-700 rounded-lg p-4 text-center">
            <Mail className="w-8 h-8 text-green-600 dark:text-green-400 mx-auto mb-2" />
            <div className="text-2xl font-bold text-green-600 dark:text-green-400">
              {emailNotificationsCount}
            </div>
            <div className="text-sm text-green-700 dark:text-green-300">
              E-Mail-Benachrichtigungen
            </div>
          </div>
          <div className="bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-700 rounded-lg p-4 text-center">
            <Settings className="w-8 h-8 text-purple-600 dark:text-purple-400 mx-auto mb-2" />
            <div className="text-2xl font-bold text-purple-600 dark:text-purple-400">
              0
            </div>
            <div className="text-sm text-purple-700 dark:text-purple-300">
              Automatisierte Aktionen
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
